"use strict";
import { jsx, jsxs } from "react/jsx-runtime";
import React from "react";
import _ from "underscore";
import Account from "../api/account";
import Api from "../api/api";
import CarrierTypeAhead from "./carrier_typeahead";
import DisablingButton from "../components/disabling_button";
import DocumentBrowser from "./react_document_browser";
import "./documents_service";
import generalFormatter from "../formatters/general";
import Paginator from "../util/paginator";
import reactUtils from "../react_utils";
import WaitingSpinner from "../components/waiting_spinner";
import {
  GroupedDocumentBrowserModel,
  GroupIDGroupCreator
} from "./grouped_document_browser_model";
import { title } from "../formatters/documents";
var bem = reactUtils.makeBem("email-merger");
function perPage() {
  return 5;
}
function documentTypesForEmail(email) {
  return _.chain(email.document_batch.documents).map((document) => {
    if (_.contains(
      ["invoice", "rateConfirmation", "billOfLading"],
      document.type
    )) {
      return title(document);
    } else {
      return "Other";
    }
  }).groupBy(_.identity).pairs().map(([t, ts]) => `${t} (${ts.length})`).value();
}
function mergeHeader() {
  return /* @__PURE__ */ jsx("div", { className: bem("__header"), children: "Merge Emails" });
}
function mergeText() {
  return /* @__PURE__ */ jsx("div", { className: "alert-box--highlight", children: "After merging you will be redirected to the dashboard where the merged email will appear in the New queue. You will be able to process the merged email after the merging processes complete. This may take a few minutes." });
}
function modelForBrowser(documentBatch) {
  return new GroupedDocumentBrowserModel(
    new GroupIDGroupCreator(
      documentBatch.documents,
      documentBatch.document_groups
    ),
    () => {
      return false;
    },
    null
  );
}
function emailsHeader() {
  return /* @__PURE__ */ jsxs("div", { className: "row factor-invoice__search-headers-row email-merger__results-header-row", children: [
    /* @__PURE__ */ jsx("div", { className: "small-1 column", children: "\xA0" }),
    /* @__PURE__ */ jsx("div", { className: "small-3 column factor-invoice__search-header", children: "SENDER INFORMATION" }),
    /* @__PURE__ */ jsx("div", { className: "small-2 column factor-invoice__search-header", children: "DATE" }),
    /* @__PURE__ */ jsx("div", { className: "small-2 column factor-invoice__search-header", children: Account.carrierTerm().toUpperCase() }),
    /* @__PURE__ */ jsx("div", { className: "small-2 column factor-invoice__search-header", children: "DOCUMENTS" })
  ] });
}
function pagination(props, state) {
  return /* @__PURE__ */ jsx(
    Paginator,
    {
      location: props.location,
      numberOfPages: numberOfPages(state),
      onSelectPage: props.onSelectPage
    }
  );
}
function cancelButton(props) {
  return /* @__PURE__ */ jsx(
    "button",
    {
      className: "button--caution email__merge-cancel-button",
      onClick: props.onCancel,
      children: "Cancel"
    }
  );
}
function currentPage(props, state) {
  return _.min([
    parseInt(props.location.query["page"] || "1"),
    numberOfPages(state)
  ]);
}
function startOffset(props, state) {
  return perPage() * (currentPage(props, state) - 1);
}
function numberOfPages(state) {
  return Math.ceil(state.emailMessages.length / perPage());
}
function emailsWithoutCurrent(props, emails) {
  return emails.filter((email) => email.id != props.emailId);
}
function emailsSelected(state) {
  return state.emailsForMergingIds.length > 0;
}
function idsForMerge(props, state) {
  return [props.emailId].concat(state.emailsForMergingIds);
}
export default React.createClass({
  // eslint-disable-line no-restricted-syntax -- Legacy React.createClass - to be migrated
  getInitialState: function() {
    return {
      emailMessages: [],
      loadingEmails: false,
      emailsForMergingIds: [],
      selectedCarrier: this.props.carrier
    };
  },
  componentDidMount: function() {
    this.loadEmails();
  },
  render: function() {
    return /* @__PURE__ */ jsx(
      WaitingSpinner,
      {
        when: this.state.loadingEmails || this.state.mergingEmails,
        children: /* @__PURE__ */ jsx("div", { className: "modal__large-container email__merge", children: this.content() })
      }
    );
  },
  loadEmails: function() {
    this.setState({ loadingEmails: true });
    Api.Email.index({ carrierId: this.state.selectedCarrier.id }).then(
      (results) => {
        this.setState({
          emailMessages: emailsWithoutCurrent(this.props, results.email_messages),
          loadingEmails: false
        });
      }
    );
  },
  content: function() {
    if (this.state.viewDocuments) {
      return /* @__PURE__ */ jsx("div", { className: "document-indexer__left-side-document-browser", children: /* @__PURE__ */ jsx(
        DocumentBrowser,
        {
          location: this.props.location,
          allowsEditing: false,
          closeBrowser: this.closeDocumentBrowser,
          model: this.state.modelForBrowser,
          collapseSingleGroup: true,
          allowsEditingPodStatus: false,
          canEditDocumentType: false
        }
      ) });
    } else {
      return /* @__PURE__ */ jsxs("div", { children: [
        mergeHeader(),
        mergeText(),
        this.actionRow(),
        /* @__PURE__ */ jsxs("div", { className: "email-merger__results-container", children: [
          emailsHeader(),
          this.mapEmails()
        ] }),
        pagination(this.props, this.state),
        /* @__PURE__ */ jsxs("div", { className: "email__merge-cancel-button-container", children: [
          cancelButton(this.props),
          this.mergeButton(true)
        ] })
      ] });
    }
  },
  actionRow: function() {
    return /* @__PURE__ */ jsxs("div", { className: bem("__action-row"), children: [
      this.mergeButton(false),
      this.carrierSelector()
    ] });
  },
  carrierSelector: function() {
    return /* @__PURE__ */ jsxs(
      "div",
      {
        className: bem("__action-item") + " " + bem("__typeahead-container"),
        children: [
          /* @__PURE__ */ jsxs("span", { className: bem("__carrier-filter-label"), children: [
            Account.carrierTerm().toUpperCase(),
            " FILTER:"
          ] }),
          /* @__PURE__ */ jsx("div", { className: bem("__carrier-typeahead"), children: /* @__PURE__ */ jsx(
            CarrierTypeAhead,
            {
              onSelectCarrier: this.carrierSelected,
              onClearCarrier: this.carrierCleared,
              onFocus: _.partial(this.selectionChange, 0),
              showTextArea: true,
              includeUnknown: true,
              carrier: this.state.selectedCarrier
            }
          ) }),
          /* @__PURE__ */ jsx(
            "button",
            {
              onClick: this.resetToEmailCarrier,
              className: "dashboard__clear-carrier-filter-button inactive-gradient",
              children: "Reset"
            }
          )
        ]
      }
    );
  },
  resetToEmailCarrier: function() {
    this.setState({ selectedCarrier: this.props.carrier }, this.loadEmails);
  },
  carrierSelected: function(carrier) {
    this.setState({ selectedCarrier: carrier }, this.loadEmails);
  },
  mergeButton: function(forReskin) {
    const className = forReskin ? "show_for_reskin" : "show_for_non_reskin";
    return /* @__PURE__ */ jsx(
      "div",
      {
        className: bem("__action-item") + " email__merge-merge-button " + className,
        children: /* @__PURE__ */ jsx(
          DisablingButton,
          {
            disabled: !emailsSelected(this.state),
            onClick: this.mergeEmails,
            disabledText: "Select Email(s) for Merge",
            className: "button--progress",
            children: "Merge Selected Emails"
          }
        )
      }
    );
  },
  mergeEmails: function() {
    this.setState({ mergingEmails: true });
    Api.Email.merge(idsForMerge(this.props, this.state)).then((results) => {
      this.setState({ mergingEmails: false });
    }).then(this.props.mergeComplete);
  },
  emailsForMergingIdsChanged: function(e) {
    let ids;
    const existing = this.state.emailsForMergingIds;
    const newId = parseInt(e.target.value);
    if (_.contains(existing, newId)) {
      const index = existing.indexOf(newId);
      existing.splice(index, 1);
      ids = existing;
    } else {
      ids = existing.concat(newId);
    }
    this.setState({ emailsForMergingIds: ids });
  },
  mapEmails() {
    const messages = this.state.emailMessages.slice(
      startOffset(this.props, this.state),
      startOffset(this.props, this.state) + perPage()
    );
    if (messages.length > 0) {
      return _.map(messages, (emailMessage) => {
        return /* @__PURE__ */ jsx(
          "div",
          {
            className: "row factor-invoice__search-items-container email-merger__results-row",
            children: /* @__PURE__ */ jsxs("div", { className: "row", children: [
              /* @__PURE__ */ jsx("div", { className: "small-1 column factor_invoice__search-item", children: /* @__PURE__ */ jsx(
                "input",
                {
                  type: "checkbox",
                  value: emailMessage.id,
                  checked: _.contains(
                    this.state.emailsForMergingIds,
                    emailMessage.id
                  ),
                  onChange: this.emailsForMergingIdsChanged
                }
              ) }),
              /* @__PURE__ */ jsxs("div", { className: "small-3 column factor_invoice__search-item", children: [
                /* @__PURE__ */ jsx("div", { children: emailMessage.subject }),
                /* @__PURE__ */ jsx("div", { children: emailMessage.sender_address })
              ] }),
              /* @__PURE__ */ jsx("div", { className: "small-2 column factor_invoice__search-item", children: generalFormatter.superShortDate(emailMessage.created_at) + " " + generalFormatter.superShortTime(emailMessage.created_at) }),
              /* @__PURE__ */ jsx("div", { className: "small-2 column factor_invoice__search-item", children: emailMessage.carrier && emailMessage.carrier.name || "Unknown " + Account.carrierTerm() }),
              /* @__PURE__ */ jsx("div", { className: "small-2 column factor_invoice__search-item ", children: /* @__PURE__ */ jsx(
                "div",
                {
                  className: "factor-invoice__documents-icon",
                  onClick: _.partial(
                    this.openDocumentBrowser,
                    emailMessage.document_batch
                  ),
                  children: /* @__PURE__ */ jsx("div", { className: "factor-invoice__documents-count", children: documentTypesForEmail(emailMessage).join(", ") })
                }
              ) })
            ] })
          },
          "email_message__" + emailMessage.id
        );
      });
    } else {
      return /* @__PURE__ */ jsxs("div", { className: "email-merger__no-emails", children: [
        "There are no email messages for that ",
        Account.carrierTermLower(),
        "."
      ] });
    }
  },
  closeDocumentBrowser: function() {
    this.setState({ viewDocuments: false });
  },
  openDocumentBrowser: function(documentBatch) {
    var model = modelForBrowser(documentBatch);
    this.setState({ modelForBrowser: model, viewDocuments: true });
  }
});
